import MAGIC_LINK_TYPES from './magic-link/types';
import WEALTH_TYPES from './wealth/types';
import POCKET_TYPES from './pocket/types';

export default {
  ...MAGIC_LINK_TYPES,
  ...WEALTH_TYPES,
  ...POCKET_TYPES,
};
